import { render, staticRenderFns } from "./AddOrUpdateRegionForm.vue?vue&type=template&id=65dec451"
import script from "./AddOrUpdateRegionForm.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateRegionForm.vue?vue&type=script&lang=js"
import style0 from "./AddOrUpdateRegionForm.vue?vue&type=style&index=0&id=65dec451&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports